export default function SessionExpiredModal({ onClose, onFechar }) {
  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md shadow-lg">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
            <span className="text-red-600 font-bold">⚠</span>
          </div>
          <h2 className="text-lg font-bold text-gray-800">Sessão expirada</h2>
        </div>
        <p className="text-gray-600 mb-6">
          A sessão de caixa anterior ainda está aberta e passou do período operacional. Você precisa fechá-la e abrir uma nova sessão.
        </p>
        <button
          onClick={onFechar}
          className="w-full bg-red-600 text-white py-2 px-4 rounded-lg font-semibold hover:bg-red-700"
        >
          Fechar sessão
        </button>
      </div>
    </div>
  );
}
